import i18n from "@/i18n";
import type { ProviderNodeProps } from "@/types/ui";
import { ProviderIcon } from "../ProviderIcon";
import { CircularSpinner } from "./CircularSpinner";
import * as styles from "./LiveLogTree.styles";
import { StatusBadge } from "./StatusBadge";

const ProviderNode = ({ providerName, status, label, entries }: ProviderNodeProps) => {
  return (
    <div className={styles.providerNode}>
      <span className={styles.providerNodeExpandIcon}>▸</span>
      <CircularSpinner status={status} size={14} />
      <ProviderIcon provider={providerName} title={providerName} />
      <StatusBadge status={status} label={label} />
      {!!entries?.length && (
        <div className={styles.providerNodeEntriesWrapper}>
          {entries.slice(0, 1).map((entry, idx) => (
            <span
              key={entry.id ?? `${entry.timestamp}-${idx}`}
              className={styles.providerNodeEntryMessage}
              title={entry.key ? i18n.t(`backendLogs:${entry.key}`, { ...entry.params }) : entry.message}
            >
              {entry.key ? i18n.t(`backendLogs:${entry.key}`, { ...entry.params }) : entry.message}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export { ProviderNode };
